'use strict'

// 积分商城正式环境域名：
// h5：m.yos168.com/point
// pc：point.yos168.com
// 后台：point.yos168.com/admin
// api：api.yos168.com/point

var apis = process.env.NODE_ENV === 'development' ? '/point/api' : ''

const REG = {
  LINKMAN: /^[a-zA-Z|\d|\u4e00-\u9fa5]*$/, //只能是数字，字母或者中文
  ADDRESS: /^[a-zA-Z|\d|\u0391-\uFFE5]*$/, //只能是数字，字母或者中文和中文标点符号
  MOBILE: /^1[0-9][0-9]\d{8}$/ // 手机
}

const Api = {
  url: process.env.VUE_APP_URL,
  apis: apis,
  token: 'http://www.lessoshangcheng.com/auth/api/auth2u/token', // 获取Token
  userInfo:'/common/v1/users/current_user', // 用户信息
  orderState: apis +  '/client/v1/orders/statistics', // 订单统计
  orders: apis + '/client/v1/orders', // 订单列表
  orderDetail: apis + '/client/v1/orders/', // 订单明细
  pointsList: apis +  '/client/v1/points', // 店铺积分列表
  shopInfo: apis + '/client/v1/points/{merchantCode}/shopInfo', // 店铺信息 xxx
  pointDetail:apis +  '/client/v1/points/', // 积分明细列表
  productsList: apis + '/client/v1/products', // 礼品列表
  productsDetail:apis +  '/client/v1/:merchantCode/products/', // 礼品详情 xxx
  carts: apis + '/client/v1/carts', // 购物车（结算）cart
  addCart: apis + '/client/v1/carts', // 添加购物车add
  putCart: apis + '/client/v1/carts', // 修改购物车
  delCart: apis + '/client/v1/carts', // 删除购物车
  submitCart: apis + '/client/v1/carts/submit', // 提交订单
  addrDefault: apis + '/client/v1/addresses/', // 收货地址默认
  batchAdd:apis +  '/client/v1/carts/batchAdd', // 再次兑换
  areas: apis + '/client/v1/areas', // 省
  region:apis +  '/client/v1/areas/', // 市
  city: apis + '/client/v1/areas/', // 区
  
}

export default {
  Api,
  REG
}
